import { useMutation, useQueryCache } from "react-query";
import { ChampionshipGenderAPI } from "api/admin/championshipGender";
import { CHAMPIONSHIP_GENDERS } from "helpers/constants";
import dispatchToast from "helpers/dispatchToast";

export default function useRemoveChampionshipGenders() {
  const queryCache = useQueryCache();

  return useMutation(ChampionshipGenderAPI.remove, {
    onSuccess: ({ message }, { onSuccess = () => {} }) => {
      queryCache.invalidateQueries(CHAMPIONSHIP_GENDERS);

      dispatchToast({ message, type: "success" });
      onSuccess();
    },
  });
}
